import React from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

const IndianPhoneInput = ({ value, onChange, testId, disabled }) => {
  return (
    <div className="indian-phone-input" data-testid={testId}>
      <PhoneInput
        international
        countryCallingCodeEditable={false}
        defaultCountry="IN"
        countries={['IN']}
        value={value}
        onChange={onChange}
        placeholder="Enter phone number"
        disabled={disabled}
      />
    </div>
  );
};

export default IndianPhoneInput;
